const VendorsData = [
  {
    id: 1,
    name: "Aarogya Pharmacy",
    location: "Indore, Madhya Pradesh",
    contact: "0731-1234567",
    email: "aarogyapharmacy@gmail.com",
    availableMedicines: [
      { name: "Paracetamol", company: "ABC Pharma", expiryDate: "12/2025", strength: "500mg", price: "20" },
      { name: "Amoxicillin", company: "XYZ Pharma", expiryDate: "11/2024", strength: "250mg", price: "30" },
      { name: "Cetirizine", company: "PQR Labs", expiryDate: "09/2024", strength: "10mg", price: "40" },
      { name: "Vitamin C", company: "MedPlus", expiryDate: "03/2026", strength: "1000mg", price: "50" },
      { name: "Ibuprofen", company: "CureTech", expiryDate: "06/2025", strength: "400mg", price: "25" },
    ],
    openingHours: "9:00 AM - 8:00 PM",
    latitude: 22.7196,
    longitude: 75.8577,
    rating: 4.2,
    services: ["Free Home Delivery", "24/7 Support"],
    website: "https://aarogyapharmacy.com",
    isUsingSoftware: true,
  },
  {
    id: 2,
    name: "Shreeji Medical Stores",
    location: "Bhopal, Madhya Pradesh",
    contact: "0755-7654321",
    email: "shreejimedicalstores@gmail.com",
    availableMedicines: [], 
    openingHours: "10:00 AM - 7:00 PM",
    latitude: 23.2599,
    longitude: 77.4126,
    rating: 4.5,
    services: [],
    website: "https://shreejimedical.com",
    isUsingSoftware: false,
    whatsappDetails: {
      contact: "0755-7654321",
      location: "Bhopal, Madhya Pradesh",
    },
  },
  {
    id: 3,
    name: "LifeCare Pharmacy",
    location: "Jabalpur, Madhya Pradesh",
    contact: "0761-3456789",
    email: "lifecarepharmacy@gmail.com",
    availableMedicines: [
      { name: "Crocin", company: "LifeWell", expiryDate: "03/2025", strength: "500mg", price: "25" },
      { name: "Atorvastatin", company: "StatinHealth", expiryDate: "06/2025", strength: "10mg", price: "120" },
      { name: "Hydrochlorothiazide", company: "HealthPlus", expiryDate: "04/2024", strength: "25mg", price: "40" },
      { name: "Fluconazole", company: "BioCure", expiryDate: "02/2025", strength: "150mg", price: "70" },
      { name: "Prednisolone", company: "CureMeds", expiryDate: "09/2025", strength: "5mg", price: "55" },
    ],
    openingHours: "9:30 AM - 8:30 PM",
    latitude: 23.1815,
    longitude: 79.9557,
    rating: 4.0,
    services: ["Home Delivery", "Online Prescription"],
    website: "https://lifecarepharmacy.com",
    isUsingSoftware: true,
  },
  {
    id: 4,
    name: "Medicare Stores",
    location: "Gwalior, Madhya Pradesh",
    contact: "0751-9876543",
    email: "medicarestores@gmail.com",
    availableMedicines: [], 
    openingHours: "8:00 AM - 10:00 PM",
    latitude: 26.2183,
    longitude: 78.1827,
    rating: 4.3,
    services: [],
    website: "https://medicarestores.com",
    isUsingSoftware: false,
    whatsappDetails: {
      contact: "0751-9876543",
      location: "Gwalior, Madhya Pradesh",
    },
  },
  {
    id: 5,
    name: "Santoshi Medical",
    location: "Ujjain, Madhya Pradesh",
    contact: "0734-1112233",
    email: "santoshi.medical@gmail.com",
    availableMedicines: [
      { name: "Ciprofloxacin", company: "PharmaCo", expiryDate: "08/2025", strength: "500mg", price: "45" },
      { name: "Levothyroxine", company: "ThyroidCare", expiryDate: "11/2024", strength: "100mcg", price: "80" },
      { name: "Insulin", company: "DiabCare", expiryDate: "10/2025", strength: "40IU", price: "400" },
      { name: "Salbutamol", company: "BreatheEasy", expiryDate: "06/2025", strength: "100mcg", price: "55" },
      { name: "Povidone Iodine", company: "CleanCare", expiryDate: "01/2026", strength: "10% solution", price: "50" },
    ],
    openingHours: "9:00 AM - 9:00 PM",
    latitude: 23.1794,
    longitude: 75.7798,
    rating: 4.1,
    services: ["Free Delivery", "Discount on Bulk Orders"],
    website: "https://santoshimedical.com",
    isUsingSoftware: true,
  },
  {
    id: 6,
    name: "Vishal Medicos",
    location: "Raipur, Chhattisgarh",
    contact: "0771-9876543",
    email: "vishalmedicos@gmail.com",
    availableMedicines: [
      { name: "Paracetamol", company: "PharmaCare", expiryDate: "01/2025", strength: "500mg", price: "18" },
      { name: "Cough Syrup", company: "CureEase", expiryDate: "12/2025", strength: "100ml", price: "60" },
      { name: "Vitamin D", company: "MedEx", expiryDate: "03/2024", strength: "1000IU", price: "75" },
      { name: "Omeprazole", company: "BioMeds", expiryDate: "06/2025", strength: "20mg", price: "55" },
      { name: "Metformin", company: "MetHealth", expiryDate: "09/2025", strength: "500mg", price: "40" },
    ],
    openingHours: "9:30 AM - 7:00 PM",
    latitude: 21.2514,
    longitude: 81.6296,
    rating: 4.4,
    services: ["Free Home Delivery", "24/7 Customer Support"],
    website: "https://vishalmedicos.com",
    isUsingSoftware: true,
  },
  {
    id: 7,
    name: "Krishna Pharmacy",
    location: "Jabalpur, Madhya Pradesh",
    contact: "0761-2345678",
    email: "krishnapharmacy@gmail.com",
    availableMedicines: [], 
    openingHours: "10:00 AM - 8:00 PM",
    latitude: 23.1815,
    longitude: 79.9557,
    rating: 4.6,
    services: [],
    website: "https://krishnapharmacy.com",
    isUsingSoftware: false,
    whatsappDetails: {
      contact: "0761-2345678",
      location: "Jabalpur, Madhya Pradesh",
    },
  },
  {
    id: 8,
    name: "Sai Medical",
    location: "Raipur, Chhattisgarh",
    contact: "0771-5551234",
    email: "saimedical@gmail.com",
    availableMedicines: [
      { name: "Glucose", company: "DiabetesCare", expiryDate: "06/2025", strength: "500mg", price: "15" },
      { name: "Sildenafil", company: "HealthMed", expiryDate: "04/2025", strength: "50mg", price: "150" },
      { name: "Hydrochlorothiazide", company: "PharmaLife", expiryDate: "08/2024", strength: "25mg", price: "30" },
      { name: "Ranitidine", company: "StomachCare", expiryDate: "12/2025", strength: "150mg", price: "20" },
      { name: "Folic Acid", company: "HealthyCare", expiryDate: "01/2026", strength: "400mcg", price: "10" },
    ],
    openingHours: "9:00 AM - 9:00 PM",
    latitude: 21.2514,
    longitude: 81.6296,
    rating: 4.0,
    services: ["Discount on Bulk Orders", "Free Delivery"],
    website: "https://saimedical.com",
    isUsingSoftware: true,
  },
  {
    id: 9,
    name: "Apollo Pharmacy",
    location: "Delhi, India",
    contact: "011-4444555",
    email: "delhi.apollopharmacy@gmail.com",
    availableMedicines: [
      { name: "Omeprazole", company: "ApolloMed", expiryDate: "05/2025", strength: "20mg", price: "100" },
      { name: "Azithromycin", company: "Biotech Pharma", expiryDate: "01/2025", strength: "250mg", price: "120" },
      { name: "Vitamin D3", company: "SunPharma", expiryDate: "03/2024", strength: "1000IU", price: "30" },
      { name: "Loratadine", company: "Horizon Pharma", expiryDate: "09/2025", strength: "10mg", price: "40" },
      { name: "Amoxicillin", company: "Omega Pharma", expiryDate: "07/2025", strength: "500mg", price: "80" },
    ],
    openingHours: "8:00 AM - 8:00 PM",
    latitude: 28.6139,
    longitude: 77.2090,
    rating: 4.7,
    services: ["Home Delivery", "Online Orders"],
    website: "https://apollopharmacy.com",
    isUsingSoftware: true,
  },
  {
    id: 10,
    name: "MedPlus Pharmacy",
    location: "Mumbai, Maharashtra",
    contact: "022-9998887",
    email: "mumbai.medpluspharmacy@gmail.com",
    availableMedicines: [
      { name: "Paracetamol", company: "MedPlus", expiryDate: "04/2025", strength: "500mg", price: "18" },
      { name: "Metformin", company: "MedLife", expiryDate: "12/2024", strength: "500mg", price: "50" },
      { name: "Ibuprofen", company: "CureTech", expiryDate: "06/2025", strength: "400mg", price: "25" },
      { name: "Sildenafil", company: "LifeWell", expiryDate: "02/2025", strength: "50mg", price: "200" },
      { name: "Levothyroxine", company: "ThyroMed", expiryDate: "11/2024", strength: "100mcg", price: "100" },
    ],
    openingHours: "9:00 AM - 9:00 PM",
    latitude: 19.0760,
    longitude: 72.8777,
    rating: 4.3,
    services: ["Free Home Delivery", "Discount Offers"],
    website: "https://medpluspharmacy.com",
    isUsingSoftware: true,
  },
  

];

export default VendorsData;
